import React from 'react';
import Icon from 'common/components/svg_icon';

const HeaderButtons = ({ toggleRightDrawer, params }) => {
  if (params.userType === 'client') {
    return null;
  }

  return (
    <div className="hide-for-large button-wrapper">
      <button type="button" onClick={toggleRightDrawer}
          className="btn btn-icon-only btn-filter header-btn-filter">
        <Icon extraClasses="svg-icon-lg filter" icon="filter" />
      </button>
    </div>
  );
}

export default HeaderButtons;
